import React, { useState, useEffect, useCallback } from "react";
import { Dropdown, Menu, message, Switch } from "antd";
import { DownOutlined } from "@ant-design/icons";
import Popup from "../components/Popup";
import ScreenLoader from "./ScreenLoader";
import $ from "jquery";

const Header = ({ showToggle }) => {
  // Define states
  const [signoutredirectionStatus, setSignoutredirectionStatus] =
    useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [adminName, setAdminName] = useState("");
  const [switchStatus, setSwitchStatus] = useState(false);
  const [isToggle, setToggle] = useState(false);
  // Component did mount equivalent
  useEffect(() => {
    const consortia_name = localStorage.getItem("consortia_name");
    setAdminName(consortia_name);

    if (localStorage.getItem("PHIStatus") === "true") {
      setSwitchStatus(true);
      try {
        showToggle(true);
      } catch (error) { }
    } else if (localStorage.getItem("PHIStatus") === "false") {
      setSwitchStatus(false);
      try {
        showToggle(false);
      } catch (error) { }
    }
  }, [showToggle]);

  // Confirm logout
  const confirm = useCallback(() => {
    setSignoutredirectionStatus(true);
    localStorage.clear();
    message.success("Logged out successfully.");
    window.location.assign("/");
  }, []);

  // Show modal
  const showModal = () => setModalVisible(true);

  // Close modal and logout
  const handleOk = () => {
    setModalVisible(false);
    localStorage.clear();
    confirm();
  };

  // Hide modal
  const handleCancel = () => setModalVisible(false);

  // Change PHI status
  // const onChange = (checked) => {
  //   setSwitchStatus(checked);
  //   localStorage.setItem("PHIStatus", checked);
  //   showToggle(checked);
  // };

  // Toggle sidebar visibility
  const onToggleClicked = (e) => {
    e.preventDefault();
    if (e.target.className === "fas fa-bars") {
      if (!isToggle) {
        $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
        setToggle(true);
      } else {
        $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
        setToggle(false);
      }
    }
  };

  const menu = (
    <Menu>
      <Menu.Item>
        <a href="/change_password">
          <i className="fas fa-key"></i> Change Password
        </a>
      </Menu.Item>
      <Menu.Item>
        <a href="#" rel="noopener noreferrer" onClick={showModal}>
          <i className="fas fa-sign-out-alt"></i> Sign Out
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="header-section">
      <ScreenLoader />
      <div className="row">
        <div className="col-8 col-sm-8 col-xs-8 col-md-8 col-lg-9 col-xl-9">
          <div className="d-flex align-items-center main-heading">
            <span className="toggle-sidebar" onClick={onToggleClicked}>
              <i className="fas fa-bars"></i>
            </span>
            <div
              className="d-none d-sm-none d-xs-none d-md-flex d-lg-flex d-xl-flex
              align-items-center"
            >
              <div className="d-flex">
                <a href={localStorage.getItem('is_site_manager')=="yes"?"/mystudies/dashboard":"/dashboard"}>
                  <div
                    className="d-flex"
                    style={{
                      paddingRight: 3,
                      position: "relative",
                      left: -14,
                    }}
                  >
                    <img
                      style={{
                        maxWidth: 53,
                      }}
                      src={require("../../assets/img/logo2.png")}
                      alt="logo"
                    />
                    <img
                      style={{
                        maxWidth: 154,
                        maxHeight: 38,
                        position: "relative",
                        top: 5,
                      }}
                      src={require("../../assets/img/logo1.png")}
                      alt="logo"
                    />
                  </div>
                </a>
                <img
                  src={require("../../assets/img/grey-header-line.png")}
                  style={{
                    height: 27,
                    marginTop: 5,
                    marginLeft: -3,
                  }}
                  alt="img"
                />
                {localStorage.getItem("consortia_company_member_name") == "RAPA" ? (
                  <div
                    style={{
                      paddingRight: 3,
                      position: "relative",
                      left: -2,
                    }}
                  >
                    <img
                      style={{
                        maxWidth: 154,
                        maxHeight: 38,
                        position: "relative",
                        top: 5,
                        marginLeft: 10
                      }}
                      src={require("../../assets/img/rapa-2-logo.png")}
                      alt="logo"
                    />
                  </div>
                ) : (
                  <p className="header-member-name">
                    Consortia Portal |{" "}
                    {localStorage.getItem("consortia_company_level")}
                  </p>
                )}

              </div>
            </div>
            <div className="d-block d-sm-block d-xs-block d-md-none d-lg-none d-xl-none">
              <h1>
                <a className="dashboard-heading" href={localStorage.getItem('is_site_manager')=="yes"?"/mystudies/dashboard":"/dashboard"}>
                  <div
                    className="d-flex"
                    style={{
                      paddingRight: 3,
                      position: "relative",
                      left: -14,
                    }}
                  >
                    <img
                      style={{
                        maxWidth: 53,
                      }}
                      src={require("../../assets/img/logo2.png")}
                      alt="logo"
                      className="logo1"
                    />
                    <img
                      style={{
                        maxWidth: 154,
                        maxHeight: 38,
                        position: "relative",
                        top: 5,
                      }}
                      src={require("../../assets/img/logo1.png")}
                      alt="logo"
                      className="logo2"
                    />
                  </div>
                </a>
              </h1>
            </div>
          </div>
        </div>
        <div className="col-4 col-sm-4 col-xs-4 col-md-4 col-lg-3 col-xl-3">
          <div className="d-flex justify-content">
            <Dropdown overlay={menu}>
              <a
                href="#"
                className="text-white logout-link ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <img
                  src="/assets/img/profile_img.png"
                  style={{ width: "20px", marginRight: "-5px" }}
                  onClick={(e) => e.preventDefault()}
                />
                <span className="username">
                  {localStorage.getItem("consortia_name")}
                </span>
                <DownOutlined />
              </a>
            </Dropdown>
          </div>
        </div>
      </div>
      {/* Start confirm logout modal */}
      <Popup
        title="Confirm"
        visible={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Yes"
        cancelText="No"
        style={{ maxWidth: 480 }}
      >
        <h6>Are you sure you want to sign out?</h6>
      </Popup>
      {/* End confirm logout modal */}
    </div>
  );
};

export default Header;
